/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientDataRecordedDateModel } from '../../models/patient-data-recorded-date-model';

export interface UpdatePatientDataRecordedDate$Params {
  dataID?: number;
  isBehaviorData?: boolean;
  recordedDate?: string;
  originalRecordedDate?: string;
  originalModifiedDate?: string;
}

export function UpdatePatientDataRecordedDate(http: HttpClient, rootUrl: string, params?: UpdatePatientDataRecordedDate$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientDataRecordedDateModel>> {
  const rb = new RequestBuilder(rootUrl, UpdatePatientDataRecordedDate.PATH, 'post');
  if (params) {
    rb.query('dataID', params.dataID, {});
    rb.query('isBehaviorData', params.isBehaviorData, {});
    rb.query('recordedDate', params.recordedDate, {});
    rb.query('originalRecordedDate', params.originalRecordedDate, {});
    rb.query('originalModifiedDate', params.originalModifiedDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientDataRecordedDateModel>;
    })
  );
}

UpdatePatientDataRecordedDate.PATH = '/api/Staff/UpdatePatientDataRecordedDate';
